import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchPromotions = createAsyncThunk(
    'promotions/fetchPromotions',
    async (limit = null, { rejectWithValue }) => {
        try {
            const params = {}
            if(limit != null){
                params.limit = limit
            }
            const response = await callAPIWithoutAuth(
                apiUrls.promotionListing,
                params,
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch promotions');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const PromotionsSlice = createSlice({
    name: 'promotions',
    initialState: {
        promotions: [],
        data: [],
        loading: false,
        error: null
    },
    reducers: {
        clearPromotionsError: (state) => {
            state.error = null;
        },
        clearPromotions: (state) => {
            state.promotions = [];
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPromotions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPromotions.fulfilled, (state, action) => {
                state.loading = false;
                state.promotions = action.payload;
                state.data = action.payload.data || action.payload;
            })
            .addCase(fetchPromotions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearPromotionsError, clearPromotions } = PromotionsSlice.actions;
export default PromotionsSlice.reducer;